"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LogManager_1 = require("../Log/LogManager");
const Entity_1 = require("../Common/Entity");
const Chat_1 = require("./Chat");
const ChatCommand_1 = require("./ChatCommand");
const ChatEvent_1 = require("./ChatEvent");
const NullCommandHub_1 = require("../Engine/Command/Port/NullCommandHub");
const NullEventHub_1 = require("../Engine/Event/Port/NullEventHub");
const ChatMessageDto_1 = require("./Protocol/ChatMessageDto");
const ChatMessageUtils_1 = require("./Protocol/ChatMessageUtils");
class ChatMessage extends Entity_1.Entity {
    constructor(isService, cmdHub, evtHub, chatMessage) {
        super(isService, ChatMessage.logger, ChatCommand_1.ChatCommand.Category, cmdHub, ChatEvent_1.ChatEvent.Category, evtHub);
        this._id = "";
        this._version = ChatMessage.CurrentVersion;
        //訊息發送時間，存UTC, 型別是C# DataTime.Binary
        //因為FM.json不支援DateTime且目前沒辦法換JavaScript的Json Library
        this._timeStamp = 0;
        this._belongToChatId = "";
        //傳送者
        this._speaker = "";
        //接收者，目前為了與Web.Client相容先留著，之後不會用到
        this._recipient = "";
        //要傳送給對方的訊息
        this._text = "";
        this._contentType = "";
        this._thumbnailChecker = async () => false;
        this._thumbnailSupplier = async () => new Blob();
        this._attachmentChecker = async () => false;
        this._attachmentSupplier = async () => new Blob();
        if (chatMessage) {
            const nowTimeStamp = Date.now();
            if (chatMessage.id)
                this._id = chatMessage.id;
            else {
                if (!chatMessage.BelongToChatId)
                    throw new Chat_1.ChatError("Invalid BelongToChatId.");
                //if (!chatMessage.Speaker) throw new ChatError("Invalid Speaker.");
                const timeStamp = chatMessage.TimeStamp || nowTimeStamp;
                this._id = ChatMessage.GenerateId(timeStamp, chatMessage.BelongToChatId, chatMessage.Speaker || "");
            }
            this._version = chatMessage.version || this._version;
            this._timeStamp = chatMessage.TimeStamp || nowTimeStamp;
            this._belongToChatId = chatMessage.BelongToChatId || this._belongToChatId;
            this._speaker = chatMessage.Speaker || this._speaker;
            this._recipient = chatMessage.Recipient || this._recipient;
            this._text = chatMessage.Text || this._text;
            this._contentType = chatMessage.ContentType || this._contentType;
            this._thumbnailChecker = chatMessage.thumbnailChecker || this._thumbnailChecker;
            this._thumbnailSupplier = chatMessage.thumbnailSupplier || this._thumbnailSupplier;
            this._attachmentChecker = chatMessage.attachmentChecker || this._attachmentChecker;
            this._attachmentSupplier = chatMessage.attachmentSupplier || this._attachmentSupplier;
        }
    }
    set id(value) { this._id = value; }
    get id() { return this._id; }
    set version(value) { this._version = value; }
    get version() { return this._version; }
    set TimeStamp(value) { this._timeStamp = value; }
    get TimeStamp() { return this._timeStamp; }
    set BelongToChatId(value) { this._belongToChatId = value; }
    get BelongToChatId() { return this._belongToChatId; }
    get Speaker() { return this._speaker; }
    get Recipient() { return this._recipient; }
    get Text() { return this._text; }
    get ContentType() { return this._contentType; }
    ToChatMessageDto() {
        return new ChatMessageDto_1.ChatMessageDto({
            id: this.id,
            timeStamp: this.TimeStamp,
            belongToChatId: this.BelongToChatId,
            speaker: this.Speaker,
            recipient: this.Recipient,
            text: this.Text,
            contentType: this.ContentType,
            thumbnailChecker: this.thumbnailChecker,
            thumbnailSupplier: this.thumbnailSupplier,
            attachmentChecker: this.attachmentChecker,
            attachmentSupplier: this.attachmentSupplier
        });
    }
    static FromChatMessageDto(isService, cmdHub, evtHub, cmDto) {
        return new ChatMessage(isService, cmdHub, evtHub, {
            id: cmDto.id,
            version: Chat_1.Chat.CurrentVersion,
            TimeStamp: cmDto.timeStamp,
            BelongToChatId: cmDto.belongToChatId,
            Speaker: cmDto.speaker,
            Recipient: cmDto.recipient,
            Text: cmDto.text,
            ContentType: cmDto.contentType,
            thumbnailChecker: cmDto.thumbnailChecker,
            thumbnailSupplier: cmDto.thumbnailSupplier,
            attachmentChecker: cmDto.attachmentChecker,
            attachmentSupplier: cmDto.attachmentSupplier,
        });
    }
    static GenerateId(timestamp, belongToChatId, speaker) {
        const beforJoinString = [belongToChatId, timestamp.toString(), speaker];
        return beforJoinString.join("_");
    }
    toString() { return JSON.stringify(this.ToChatMessageDto()); }
    IsText() { return ChatMessageUtils_1.ChatMessageUtils.IsContentTypeText(this.ContentType); }
    IsImage() { return ChatMessageUtils_1.ChatMessageUtils.IsContentTypeImage(this.ContentType); }
    IsAudio() { return ChatMessageUtils_1.ChatMessageUtils.IsContentTypeAudio(this.ContentType); }
    ThumbnailName() { return this.IsContentTypeWithThumbnail() ? ChatMessageUtils_1.ChatMessageUtils.ThumbnailName(this.Text) : ""; }
    IsContentTypeWithThumbnail() { return ChatMessageUtils_1.ChatMessageUtils.IsContentTypeWithThumbnail(this.ContentType); }
    async GetThumbnailAsync() { return await ChatMessageUtils_1.ChatMessageUtils.GetContentAsync(this._thumbnailSupplier); }
    async HasThumbnailAsync() { return await ChatMessageUtils_1.ChatMessageUtils.HasContentAsync(this._thumbnailChecker, this._thumbnailSupplier); }
    InjectThumbnailSupplier(checker, supplier) {
        this._thumbnailChecker = checker;
        this._thumbnailSupplier = supplier;
    }
    get thumbnailChecker() { return this._thumbnailChecker; }
    get thumbnailSupplier() { return this._thumbnailSupplier; }
    AttachmentName() { return this.IsContentTypeWithAttachment() ? this.Text : ""; }
    IsContentTypeWithAttachment() { return ChatMessageUtils_1.ChatMessageUtils.IsContentTypeWithAttachment(this.ContentType); }
    async HasAttachmentAsync() { return await ChatMessageUtils_1.ChatMessageUtils.HasContentAsync(this._attachmentChecker, this._attachmentSupplier); }
    async GetAttachmentAsync() { return await ChatMessageUtils_1.ChatMessageUtils.GetContentAsync(this._attachmentSupplier); }
    InjectAttachmentSupplier(checker, supplier) {
        this._attachmentChecker = checker;
        this._attachmentSupplier = supplier;
    }
    get attachmentChecker() { return this._attachmentChecker; }
    get attachmentSupplier() { return this._attachmentSupplier; }
}
ChatMessage.logger = LogManager_1.logManager.GetLogger("ChatMessage");
ChatMessage.CurrentVersion = 1;
ChatMessage.INVALID_CHAT_MESSAGE = new ChatMessage(false, new NullCommandHub_1.NullCommandHub(), new NullEventHub_1.NullEventHub());
exports.ChatMessage = ChatMessage;
//# sourceMappingURL=ChatMessage.js.map